import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({ baseURL: BASE_URL, withCredentials: true });

// Attach access token to every request EXCEPT public auth endpoints
const PUBLIC_PATHS = ['/auth/register', '/auth/login', '/auth/refresh-token'];
api.interceptors.request.use((config) => {
  const isPublic = PUBLIC_PATHS.some((path) => config.url?.includes(path));
  if (!isPublic) {
    const token = localStorage.getItem('accessToken');
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auto-refresh on 401
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      try {
        const userId = localStorage.getItem('userId');
        const refreshToken = localStorage.getItem('refreshToken');
        const { data } = await axios.post(`${BASE_URL}/auth/refresh-token`, { userId, refreshToken });
        localStorage.setItem('accessToken', data.data.accessToken);
        localStorage.setItem('refreshToken', data.data.refreshToken);
        original.headers.Authorization = `Bearer ${data.data.accessToken}`;
        return api(original);
      } catch {
        localStorage.clear();
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// ── Auth ──────────────────────────────────────────────────────────────────────
export const authAPI = {
  register: (body) => api.post('/auth/register', body),
  login:    (body) => api.post('/auth/login', body),
  logout:   ()     => api.post('/auth/logout'),
  me:       ()     => api.get('/auth/me'),
  changePassword: (body) => api.patch('/auth/change-password', body),
};

// ── Emails ────────────────────────────────────────────────────────────────────
export const emailsAPI = {
  send:   (body)        => api.post('/emails/send', body),
  list:   (params)      => api.get('/emails', { params }),
  get:    (id)          => api.get(`/emails/${id}`),
  delete: (id)          => api.delete(`/emails/${id}`),
};

// ── Analytics ─────────────────────────────────────────────────────────────────
export const analyticsAPI = {
  summary:       ()           => api.get('/analytics/summary'),
  opensByHour:   ()           => api.get('/analytics/opens-by-hour'),
  email:         (id)         => api.get(`/analytics/${id}`),
  timeline:      (id, params) => api.get(`/analytics/${id}/timeline`, { params }),
  devices:       (id)         => api.get(`/analytics/${id}/devices`),
};

export default api;
